/**
 * Card Component
 *
 * Abstraction layer over MUI Card components.
 * Exports Card, CardContent, CardMedia, CardActions for convenience.
 */

import {
  CardActionAreaProps,
  CardActionsProps,
  CardContentProps,
  CardHeaderProps,
  CardMediaProps,
  CardProps,
  Card as MuiCard,
  CardActionArea as MuiCardActionArea,
  CardActions as MuiCardActions,
  CardContent as MuiCardContent,
  CardHeader as MuiCardHeader,
  CardMedia as MuiCardMedia,
} from '@mui/material';
import React from 'react';

export const Card = React.forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  return <MuiCard ref={ref} {...props} />;
});

export const CardContent = React.forwardRef<HTMLDivElement, CardContentProps>((props, ref) => {
  return <MuiCardContent ref={ref} {...props} />;
});

export const CardMedia = React.forwardRef<any, any>((props, ref) => {
  return <MuiCardMedia ref={ref} {...props} />;
});

export const CardActions = React.forwardRef<HTMLDivElement, CardActionsProps>((props, ref) => {
  return <MuiCardActions ref={ref} {...props} />;
});

export const CardHeader = React.forwardRef<HTMLDivElement, CardHeaderProps>((props, ref) => {
  return <MuiCardHeader ref={ref} {...props} />;
});

export const CardActionArea = React.forwardRef<HTMLButtonElement, CardActionAreaProps>((props, ref) => {
  return <MuiCardActionArea ref={ref} {...props} />;
});

Card.displayName = 'Card';
CardContent.displayName = 'CardContent';
CardMedia.displayName = 'CardMedia';
CardActions.displayName = 'CardActions';
CardHeader.displayName = 'CardHeader';
CardActionArea.displayName = 'CardActionArea';

export default Card;
